import getApiClient, { getAnnonymousApiClient } from "./../../../shared/api";
import {
  showInfo,
  showError,
  clearNotifications
} from "../../../notifications/ducks/actions";
import auth from "../../../shared/auth";
import invitations from "../../../shared/invitations";
import { connection } from "../../../middleware/paymentSignalRMiddleware";
import { HubConnectionState } from "@microsoft/signalr";
import { PAYMENT_PAID } from "../../payment/ducks/actions";

export const FETCHED_PAUSED_SUBSCRIPTION = "FETCHED_PAUSED_SUBSCRIPTION";
export const RESUME_SUBSCRIPTION = "RESUME_SUBSCRIPTION";
export const RESUME_SUBSCRIPTION_GET_FULL_TOKEN = "RESUME_SUBSCRIPTION_GET_FULL_TOKEN";
export const RESUME_SUBSCRIPTION_RESET_FETCHED_FULL_TOKEN = "RESUME_SUBSCRIPTION_RESET_FETCHED_FULL_TOKEN";


export function fetchPausedSubscription() {
  return (dispatch) => {
    dispatch({
      type: FETCHED_PAUSED_SUBSCRIPTION,
      payload: getApiClient().get(`/payment/PausedSubscription`
      )
    });
  };
}


export function resumeSubscription() {
  const user = auth.getUser();

  if (user.refreshToken) {
    // means we are logged in proplerly    
    return (dispatch) => {
      dispatch({
        type: RESUME_SUBSCRIPTION + "_FULFILLED",
      });
    };
  }

  if (connection.state === HubConnectionState.Disconnected) {
    connection.start().then(() => {
      connection.invoke('Subscribe', user.id).catch(e => {
        debugger;
        console.error(e);
      });
    }).catch(e => {
      debugger;
      console.error(e);
    })
  }


  return (dispatch) => {
    dispatch({
      type: RESUME_SUBSCRIPTION,
      payload: getApiClient().post(`/payment/resume`,
        {}
      )
    });
  };
}

export function getFullToken() {
  return (dispatch) => {
    dispatch({
      type: RESUME_SUBSCRIPTION_GET_FULL_TOKEN,
      payload: getApiClient().get(`/account/fullToken`)
    });
  };
}

export function resetFetchedFullToken() {
  return (dispatch) => {
    dispatch({
      type: RESUME_SUBSCRIPTION_RESET_FETCHED_FULL_TOKEN
    });
  };
}

